export default [{
  header: 'Compras',
  icon: 'PackageIcon',
  i18n: 'Apps',
  items: [
    {
      url: '/compras/panel',
      name: 'Panel',
      icon: 'GridIcon',
      slug: 'panel',
      permiso: 'WB000'
    },
  ]
}];
